import Services from './Services'

export default class Vendedor extends Services {
  constructor() {
    super()
  }

  async getVendedor(uuid) {
    try {
      let response = await this._http.get(`links/${uuid}`)
      return Promise.resolve(response)
    }
    catch (error) {
      return Promise.reject(error)
    }
  }
}
